export const PRESET_SCROLLBAR_CLASSES =
  '[&::-webkit-scrollbar]:h-1' +
  ' [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-transparent' +
  ' [&:hover::-webkit-scrollbar-thumb]:bg-slate-300' +
  ' [&::-webkit-scrollbar-thumb:hover]:bg-slate-400 [&::-webkit-scrollbar-track]:bg-transparent' +
  ' [@supports_not_selector(::-webkit-scrollbar)]:[scrollbar-width:thin]' +
  ' [@supports_not_selector(::-webkit-scrollbar)]:[scrollbar-color:transparent_transparent]' +
  ' [@supports_not_selector(::-webkit-scrollbar)]:hover:[scrollbar-color:var(--color-slate-300)_transparent]';
